function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent, Fragment } from "react";
import SignupWithTextComponent from "/components/core/signups/signup-with-text/signup-with-text-component";
import Picture from "/components/core/picture/picture-component";
import { StyledArticleItemComponent } from "./article-item-component.scss";
import CompetitorsComparisonTableComponent from "/components/segments/competitors-comparison-table/competitors-comparison-table-component";
import { withGenericConfig } from "contexts/generic-config-context";
class ArticleItemComponent extends PureComponent {
    renderSignup() {
        const { title } = this.props;
        return /*#__PURE__*/ _jsx(SignupWithTextComponent, {
            title: title
        });
    }
    renderImage() {
        const { src, alt } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: "article-image",
            children: /*#__PURE__*/ _jsx(Picture, {
                src: src,
                alt: alt
            })
        });
    }
    renderParagraph() {
        const { title, isHighlight, content } = this.props;
        return /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                title && /*#__PURE__*/ _jsx("h1", {
                    className: "paragraph-title",
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                content && /*#__PURE__*/ _jsx("div", {
                    className: "paragraph-content",
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                })
            ]
        });
    }
    renderComparisonTable() {
        return /*#__PURE__*/ _jsx(CompetitorsComparisonTableComponent, _object_spread({}, this.props));
    }
    renderHighlight() {
        const { content } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: "highlight-item",
            children: content
        });
    }
    mapPartTypeToRenderer() {
        const { partType } = this.props;
        switch(partType){
            case "paragraph":
                {
                    return this.renderParagraph;
                }
            case "signup":
                {
                    return this.renderSignup;
                }
            case "image":
                {
                    return this.renderImage;
                }
            case "highlight":
                {
                    return this.renderHighlight;
                }
            case "comparisonTable":
                {
                    return this.renderComparisonTable;
                }
        }
    }
    render() {
        const { partType, content, title } = this.props;
        const partRenderer = this.mapPartTypeToRenderer();
        return /*#__PURE__*/ _jsx(StyledArticleItemComponent, {
            className: `article-item-component ${partType}`,
            children: partRenderer()
        });
    }
    constructor(props){
        super(props);
        this.renderSignup = this.renderSignup.bind(this);
        this.renderParagraph = this.renderParagraph.bind(this);
        this.renderImage = this.renderImage.bind(this);
        this.renderHighlight = this.renderHighlight.bind(this);
        this.renderComparisonTable = this.renderComparisonTable.bind(this);
    }
}
export default withGenericConfig(ArticleItemComponent);
